import Vue from 'vue';

const state = {

};

const getters = {

};

const actions = {
    async downloadSales ({state, commit, dispatch}, data) {
        try {
            console.log('-- Download sales --');
            let dateFrom = moment(data.dateFrom);
            let dateTo = moment(data.dateTo);
            let supplierId = data.supplierId;
            let agentId = data.agentId;
            let productId = data.productId;
            let statusId = data.statusId;
            let page = data.page;
            let pageSize = data.pageSize;
            console.log(data);

            let response = await axios.get('/api/booking/ReportingBookingAgentSales', {
                params: {
                  's.SupplierId': supplierId,
                  's.AgentId': agentId,
                  's.ProductId': productId,
                  's.Status': statusId,
                  's.DateStart': dateFrom.format('YYYY-MM-DD') + ' 00:00:00',
                  's.DateEnd': dateTo.format('YYYY-MM-DD') + ' 23:59:59',
                  'page': page,
                  'pageSize': pageSize
                }
            });

            return response;
        } catch (err) {
          console.error(err);
          return false;
        }
    },

    async downloadAllSales ({state, commit, dispatch}, data) {
        try {
            console.log('-- Download  All sales --');
            let dateFrom = moment(data.dateFrom);
            let dateTo = moment(data.dateTo);
            let supplierId = data.supplierId;
            //debug
            console.log(data);

            let response = await axios.get('/api/booking/ReportingBookingAgentSalesExport', {
                params: {
                    's.SupplierId': supplierId,
                    's.DateStart': dateFrom.format('YYYY-MM-DD') + ' 00:00:00',
                    's.DateEnd': dateTo.format('YYYY-MM-DD') + ' 23:59:59'
                }
            });

            return response;
        } catch (err) {
            console.error(err);
            return false;
        }
    },

    async downloadSalesExport ({state, commit, dispatch}, data) {
        try {
            let dateFrom = moment(data.dateFrom);
            let dateTo = moment(data.dateTo);
            let supplierId = data.supplierId;
            let agentId = data.agentId;
            let productId = data.productId;
            let statusId = data.statusId;

            let response = await axios.get('/api/booking/ReportingBookingAgentSalesDownloadXXX', {
                params: {
                  's.SupplierId': supplierId,
                  's.AgentId': agentId,
                  's.PproductId': productId,
                  's.Status': statusId,
                  's.DateStart': dateFrom.format('YYYY-MM-DD') + ' 00:00:00',
                  's.DateEnd': dateTo.format('YYYY-MM-DD') + ' 23:59:59'
                },
                responseType: 'blob'
            });

            return response;
        } catch (err) {
            console.error(err);
            return false;
        }
    },
};

const mutations = {
};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/reports.js